import { DOMAIN } from 'config';

export const pathConverter = (path: string = '') => {
  return `${DOMAIN}/?mode=headerless#${path}`;
};

export const iframePaths = [
  '/style',
  '/item',
  '/report',
  '/dashboard',
  //'/analytics', // disabled due to flex monster not working in iframe
  '/marketing',
  '/order',
  '/compliance',
  '/admin',
];

export const shouldNavigate = (iframePath: string, reactPath: string): string => {
  try {
    let iframeUrl = iframePath || '';
    iframeUrl = iframeUrl.replace(/^#\/|^#|^\//, '');
    const reactUrl = reactPath.replace(/^\//, '');
    if (iframeUrl !== reactUrl) {
      return iframeUrl;
    }
  } catch (e) {
    return '';
  }
  return '';
};

export const checkIframeOrigin = (origin: string): boolean => {
  if (origin === DOMAIN) {
    return true;
  }
  if (origin === window.location.origin) {
    return true;
  }
  return false;
};
